import client from '../ApolloClient'
import gql from 'graphql-tag'
import {
  FETCH_TOP_FOLDERS, FETCH_USERS, FETCH_CONTENT,
  loadTopFolders, loadUsers, loadContent
} from '../Actions/Content'
import { failFetch } from '../Actions/Other'
// eslint-disable-next-line
import { Observable, Subject, filter, mergeMap, switchMap, map, takeUntil } from 'rxjs';

export const contentAnalyticsQuery = gql`query getContentAnalytics($accountId: ID!,
      $startDate: DateTime!, $endDate: DateTime!, $limit: Int, $offset: Int, $location: ContentLocation,
      $sortField: String, $sortDirection: String, $appProfileIds: [ID!], $groupIds: [ID!], $appType: AppType!) {
      getContentAnalytics(accountId: $accountId, startDate: $startDate, endDate: $endDate, limit: $limit, offset: $offset, location: $location,
        sortField: $sortField, sortDirection: $sortDirection, appProfileIds: $appProfileIds, groupIds: $groupIds, appType: $appType)
      {
        content {
          _id
          created
          contentType
          title
          totalViews
          totalViewsWeb
          totalViewsMobile
          thumbnailUrl
          totalLikes
          totalReactions
          totalComments
          totalShares
          totalOfflineDownloads
          avgViewDuration
          avgDurationInApp
          avgDurationInCMS
          notify
          includeInFeed
          secure
          disableSaving
          likesEnabled
          commentsEnabled
          mentionsEnabled
          displayThumbnail
          isQuickLink
        }
        count
        accountDetails{
          _id
          name
          ui_version
        }
        }
      }`

/**
  * contentEpic
  * @desc action Observer that sends a query and processes result if the action is a fetch content action
  * @param {Observable<action>} action$ Action Observable stream
  * @return {action}
*/
export const contentEpic = action$ =>
  action$.pipe(
    filter(action => action.type === FETCH_CONTENT),
    mergeMap(action => {
      const subject = new Subject()
      client.query({ query: contentAnalyticsQuery, variables: { ...action.query } })
        .then((data) => { subject.next(data) })
        .catch((error) => {
          subject.next(error)
        })
      return subject.pipe(
        map((response) => {
          if (response.data) {
            return loadContent(response.data, action.destination)
          } else {
            return failFetch(response)
          }
        }),
        takeUntil(action$.pipe(
          filter(action2 => action2.type === FETCH_CONTENT && action2.destination === action.destination)
        ))
      )
    })
  )

const folderAnalyticsQuery = gql`query getFolderAnalytics($accountId: String!,
      $startDate: DateTime!, $endDate: DateTime!, $limit: Int, $offset: Int,
      $appProfileIds: [ID!], $groupIds: [ID!], $appType: AppType!, $sortField: String, $sortDirection: String) {
  getFolderAnalytics(accountId: $accountId, startDate: $startDate, endDate: $endDate, limit: $limit, offset: $offset,
    appProfileIds: $appProfileIds, groupIds: $groupIds, appType: $appType, sortField: $sortField, sortDirection: $sortDirection) {
    folders {
      _id
      title
      totalViews
    }
    count
  }
}`

/**
  * topFoldersEpic
  * @desc action Observer that sends a query and processes result if its a fetch top folder action
  * @param {Observable<action>} action$ Action Observable stream
  * @return {action}
*/
export const topFoldersEpic = action$ =>
  action$.pipe(
    filter(action => action.type === FETCH_TOP_FOLDERS),
    switchMap(action => {
      const subject = new Subject()
      client.query({ query: folderAnalyticsQuery, variables: { ...action.query, sortField: 'totalViews', sortDirection: 'DESCENDING' } })
        .then((data) => { subject.next(data) })
        .catch((error) => {
          subject.next(error)
        })
      return subject.pipe(
        map((response) => {
          if (response.data) {
            return loadTopFolders(response.data)
          } else {
            let error
            if (response.graphQLErrors) {
              error = response.graphQLErrors[0]
            } else if (!error && response.networkError) {
              error = response.networkError.result.errors[0]
            } else {
              error = response
            }
            return failFetch(error)
          }
        })
      )
    })
  )

const userQuery = gql`query allUsers($accountId: String!,
      $startDate: DateTime!, $endDate: DateTime!, $userAdminType: UserAdminType, $onlyAdmins: Boolean, $limit: Int, $offset: Int, $appProfileIds: [ID!], $groupIds: [ID!], $sortField: String, $sortDirection: SortDirection, $appType: AppType,) {
  allUsers (accountId: $accountId, startDate: $startDate, endDate: $endDate, userAdminType: $userAdminType, onlyAdmins: $onlyAdmins, limit: $limit, offset: $offset, appProfileIds: $appProfileIds, groupIds: $groupIds, sortField: $sortField, sortDirection: $sortDirection, appType: $appType,){
    users {
      _id
      name
      registrationDate
      totalLogins
      latestActivity
      adminType
      avgDurationInApp
      avgDurationInCMS
      contentAdded
      contentFoldersAdded
      lastLogin
      lastAdminLogin
      appProfiles
      groups
    }
    count
  }
}`

/**
  * usersEpic
  * @desc action Observer that sends a query and processes result if the action is a fetch users action
  * @param {Observable<action>} action$ Action Observable stream
  * @return {action}
*/
export const usersEpic = action$ =>
  action$.pipe(
    filter(action => action.type === FETCH_USERS),
    switchMap(action => {
      const subject = new Subject()
      client.query({ query: userQuery, variables: action.query })
        .then((data) => {
          subject.next(data)
        })
        .catch((error) => {
          subject.next(error)
        })
      return subject.pipe(
        map((response) => {
          if (response.data) {
            return loadUsers(response.data)
          } else {
            return failFetch(response)
          }
        })
      )
    })
  )
